import React from "react"
import { Tooltip } from "@mantine/core"
import { TooltipContainer, IconWrapper } from "QuorumGrassroots/widgets/ReusableComponents/PACReadOnlyIcon/styles"
import { RequiredIcon } from "../RequiredIcon/RequiredIcon"

interface PACReadOnlyIconProps {
    color?: string
}

export const PACReadOnlyIcon = ({ color = "#ADB5BD" }: PACReadOnlyIconProps) => {
    return (
        <Tooltip
            label={<TooltipContainer>This field is read-only once it is a PAC-managed field</TooltipContainer>}
            position="bottom"
        >
            <IconWrapper>
                <RequiredIcon color={color} />
            </IconWrapper>
        </Tooltip>
    )
}
